var _ = require('lodash');
var dd = require('react-dd');
var dateFormat = require('dateformat');

require('./index.less.js');

var component = dd.createClass({
  __onChange: function(e){
    this.props.onChange(e.target.value);
  },
  render: function(){
    var field = this.props.field;
    var value = this.props.value;

    var initial_date = field.initial_date ? field.initial_date : dateFormat(new Date(), "m/dd/yyyy");
    var initial_name = field.initial_name ? field.initial_name : "Name";

    return (
        dd.div(
            {className: "signature-group row"},
            dd.div({className: "col-xs-5 col-sm-5 signature-input-holder"},
                dd.div({className: "input"}, initial_name),
                dd.span({className: "help-block"}, "Name")
            ),
            dd.div({className: "col-xs-3 col-sm-2 signature-input-holder"},
                dd.div(null,
                    dd.input({
                        name: field.name,
                        disabled: field.disabled ? "disabled" : null,
                        type: field.type || 'text',
                        value: value || '',
                        placeholder: field.placeholder || null,
                        className: 'form-control',
                        autoFocus: field.autofocus || false,
                        onChange: this.__onChange
                    })
                ),
                dd.span({className: "help-block"}, "Initials")
            ),
            dd.div({className: "col-xs-4 col-sm-5 signature-input-holder"},
                dd.div({className: "input"},
                    initial_date
                ),
                dd.span({className: "help-block"}, "Date")
            )
            // ),
            // dd.div({className: "clearfix"})
        )
    );
  }
});

module.exports = {
  component: component,
  validate: function(value){
    if(_.isString(value) && str.trim().length == 0){
        return 'Please enter your initials';
    }
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/react-loose-forms.bootstrap3/inputs/Initial/index.js
// module id = 431
// module chunks = 0 1 2 3 4